const setIsAIFloatButtonShowingAction = ({ commit }, payload) => {
  commit('setIsAIFloatButtonShowing', payload)
}

const setShowAISlideGeneratorModalAction = ({ commit }, payload) => {
  commit('setShowAISlideGeneratorModal', payload)
}

const setIsAIPromptHasInputAction = ({ commit }, payload) => {
  commit('setIsAIPromptHasInput', payload)
}

export default {
  setShowAISlideGeneratorModalAction,
  setIsAIPromptHasInputAction,
  setIsAIFloatButtonShowingAction,
}
